<template>
  <footer class="nk-footer-bar section section-s">
    <div class="container container-xxl">
      <div class="row gutter-vr-10px">
        <div class="col-lg-6 order-lg-last text-lg-right">
          <ul class="footer-nav">
            <!-- <li><router-link to="privacy-policy">Privacy Policy</router-link></li> -->
            <li><a href="/privacy-policy.html">Privacy Policy</a></li>
            <li><a href="/terms.html">Terms of sales</a></li>
          </ul>
        </div>
        <div class="col-lg-6">
          <div class="copyright-text copyright-text-s2">Copyright © 2020 NIPOST. </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>